import { useState } from 'react';
import { useMutation } from '@tanstack/react-query';
import { toFieldErrors } from '@/shared/api/submit';
import { fineWriteOff, revertServiceStatus } from './api';

type Props = {
  userId: number | string;
  /** Called after a successful action so the page can refetch the profile. */
  onDone: () => void;
};

const ErrorList = ({ error }: { error: unknown }) =>
  error ? (
    <>
      {Object.values(toFieldErrors(error))
        .flat()
        .map((message) => (
          <p key={message} className="text-red">
            {message}
          </p>
        ))}
    </>
  ) : null;

/** Legacy "Списать штраф": amount plus a mandatory comment. */
export const FineWriteOffBox = ({ userId, onDone, disabled }: Props & { disabled: boolean }) => {
  const [amount, setAmount] = useState('');
  const [comment, setComment] = useState('');
  const mutation = useMutation({
    mutationFn: () => fineWriteOff(userId, amount, comment),
    onSuccess: () => {
      setAmount('');
      setComment('');
      onDone();
    },
  });
  return (
    <div className="box">
      <div className="box-body">
        <div className="form-group">
          <label className="control-label">Списать штраф</label>
          <input
            type="number"
            className="form-control input-sm"
            style={{ maxWidth: 300 }}
            value={amount}
            disabled={disabled}
            placeholder="Введите сумму штрафа"
            onChange={(e) => setAmount(e.target.value)}
          />
        </div>
        <div className="form-group">
          <input
            className="form-control input-sm"
            style={{ maxWidth: 500 }}
            value={comment}
            disabled={!amount}
            placeholder="Комментарий обязателен"
            onChange={(e) => setComment(e.target.value)}
          />
        </div>
        <ErrorList error={mutation.error} />
        <button
          type="button"
          className="btn btn-success"
          disabled={!comment || mutation.isPending}
          onClick={() => mutation.mutate()}
        >
          Списать
        </button>
      </div>
    </div>
  );
};

/** Legacy "Разблокировать сервис", shown for deactivated (status 6) services. */
export const RevertStatusBox = ({ userId, onDone }: Props) => {
  const mutation = useMutation({
    mutationFn: () => revertServiceStatus(userId),
    onSuccess: onDone,
  });
  return (
    <div className="box">
      <div className="box-body">
        <label className="control-label" style={{ marginRight: 12 }}>
          Разблокировать сервис
        </label>
        <button
          type="button"
          className="btn btn-success"
          disabled={mutation.isPending}
          onClick={() => mutation.mutate()}
        >
          Разблокировать
        </button>
        {mutation.isSuccess && <span className="text-green"> Статус успешно восстановлен</span>}
        <ErrorList error={mutation.error} />
      </div>
    </div>
  );
};
